import React from 'react';
import cn from 'classnames';
import './Panel.scss';
function Panel({ className, children }) {
    return React.createElement("div", { className: cn('element-panel', className) }, children);
}
export default Panel;
